export default function () {
  return [
    { label: 'Képviselő neve', value: 'representativeUserName' },
    { label: 'Partner neve', value: 'partnerName' },
    { label: 'Partner címe', value: 'partnerAddress' },
    { label: 'Partner cégjegyzékszáma', value: 'partnerRegistrationNumber' },
    { label: 'Partner adószáma', value: 'partnerTaxNumber' },
    { label: 'Üzlet neve', value: 'shopName' },
    { label: 'Üzlet címe', value: 'shopAddress' },
    { label: 'Mai dátum', value: 'date' },
    { label: 'Kelt város', value: 'city' },
  ];
}
